import {Description, Dialog, DialogBackdrop, DialogPanel, DialogTitle} from "@headlessui/react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faTimes} from "@fortawesome/free-solid-svg-icons";
import {useBoundStore} from "../../../Store/store";
import toast from "react-hot-toast";
import * as React from "react";
import {useForm} from "react-hook-form";
import * as yup from "yup";
import {yupResolver} from "@hookform/resolvers/yup";
import {TextAreaInput} from "../../Form/TextAreaInput";
import {PrimaryButton} from "../../Buttons/PrimaryButton";
import {useEffect} from "react";
import {useTranslation} from "react-i18next";

export const EditRejectionRemarkDialog = (props) => {
    const {
        isOpen,
        onClose,
        userId,
        currentRemark,
        onUpdate
    } = props;

    const {t} = useTranslation();
    const updateRejectionRemark = useBoundStore((state) => state.updateRejectionRemark);

    const schema = yup.object({
        rejection_remark: yup.string().min(10, t('registrations.remark_min_10')).required(t('registrations.remark_required')),
    }).required()

    const {
        register,
        handleSubmit,
        formState: {errors},
        reset,
    } = useForm({
        resolver: yupResolver(schema),
        reValidateMode: 'onBlur',
        mode: 'onChange',
        defaultValues:{
            rejection_remark: currentRemark || '',
        }
    });

    useEffect(() => {
        if (isOpen) {
            reset({
                rejection_remark: currentRemark || '',
            });
        }
    }, [isOpen, currentRemark, reset]);

    const onSubmit = (data) => {
        updateRejectionRemark(userId, data)
            .then((response) => {
                if (response) {
                    onClose();
                    onUpdate();
                    toast.success(t('registrations.toast_remark_updated'));
                } else {
                    toast.error(t('registrations.toast_remark_error'));
                }
            })
    }

    return (
        <Dialog open={isOpen} onClose={() => onClose()} className="relative z-50">
            <DialogBackdrop
                transition
                className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity duration-300 ease-in-out data-[closed]:opacity-0"
            />

            <div className="fixed inset-0 flex w-screen items-center justify-center p-4">
                <DialogPanel className="w-full md:w-1/3 space-y-4 border bg-white p-12 rounded-lg">
                    <div className="flex items-start justify-between flex-wrap">
                        <DialogTitle className="font-bold text-center">{t('dialogs.edit_remark.title')}</DialogTitle>
                        <div className="ml-3 flex h-7 items-center">
                            <button
                                type="button"
                                className="relative rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none"
                                onClick={() => onClose()}
                            >
                                <span className="absolute -inset-2.5"/>
                                <span className="sr-only">Close panel</span>
                                <FontAwesomeIcon icon={faTimes} className="h-6 w-6" aria-hidden="true"/>
                            </button>
                        </div>
                    </div>
                    <Description>{t('registrations.edit_rejection_title')}</Description>

                    <form className={'grid grid-cols-1'} onSubmit={handleSubmit(onSubmit)}>
                        <div className="mb-2">
                            <TextAreaInput
                                register={register}
                                name={'rejection_remark'}
                                translationIndex={t('form.remark')}
                                errors={errors}
                                rows={4}
                            />
                        </div>

                        <div className="flex flex-row space-x-4 justify-end">
                            <PrimaryButton type="submit">
                                {t('general.actions.save')}
                            </PrimaryButton>
                        </div>
                    </form>
                </DialogPanel>
            </div>
        </Dialog>
    )
}

